import React, { useContext } from 'react'
import { Context } from './Context'
import { messageDelivery } from '../wbstdt/Wbstdt'

export default function MessageDelivery(props) {

    const { lang } = useContext(Context)

        return (
            <div className={`msg-dlv msg-dlv-${props.msg} flex-container-centered box-wsp slidedup`}>
                {messageDelivery[lang][props.msg]}
            </div>
        )

}



// WEBPACK FOOTER //
// ./src/Component/MessageDelivery.js